import { useCallback } from 'react';
import * as SignalR from '@microsoft/signalr';
import { CONNECT_BEARER } from '../constants/constants';
import { INotification, Status } from '../types/enums/SignalRAccountsStatus';
import { localStorageContainer } from '../domain/services';
import { CreditAccountsFetchStatus, useCreditAccountsState } from './zustandHooks';
import { useServiceUrls } from './queryHooks';

let connection: SignalR.HubConnection | null = null;
let connectionIsActive = false;

export const useCreditAccountsFetchStatusReceiver = () => {
  const { serviceUrls } = useServiceUrls();
  const setFetchStatus = useCreditAccountsState(state => state.setState);

  const connect = useCallback(async () => {
    if (connectionIsActive || !serviceUrls?.connectApiService) return;
    connectionIsActive = true;
    setFetchStatus({ creditAccountsFetchStatus: CreditAccountsFetchStatus.Connecting });

    connection = new SignalR.HubConnectionBuilder()
      .withUrl(`${serviceUrls.connectApiService}/CreditInformationNotificationHub`, {
        accessTokenFactory: () => localStorageContainer.getTokenByClientId(CONNECT_BEARER)!,
        transport: SignalR.HttpTransportType.WebSockets
      })
      .withAutomaticReconnect()
      .configureLogging(SignalR.LogLevel.Information)
      .build();

    await connection.start();
    setFetchStatus({ creditAccountsFetchStatus: CreditAccountsFetchStatus.Waiting });

    connection.on('ProcessStatusUpdate', (data: INotification) => {
      if (data.status === Status.StoredAccounts) {
        setFetchStatus({ creditAccountsFetchStatus: CreditAccountsFetchStatus.Finished });
        connection!.off('ProcessStatusUpdate');
        connection!.stop();
        connection = null;
        connectionIsActive = false;
      }
      if (data.status === Status.AccountsError) {
        setFetchStatus({ creditAccountsFetchStatus: CreditAccountsFetchStatus.Error });
      }
    });
  }, [serviceUrls, setFetchStatus]);

  return { connect };
};
